import angular from 'angular';
import _ from 'lodash';
import '../data/invoice/invoice.data.js';
import '../data/invoice/invoice-status.data.js';
import '../data/invoice/invoice-event.data.js';

(function () {
    'use strict';
    angular.module('app.core').factory('KissInvoiceDA', KissInvoiceDA);

    KissInvoiceDA.$inject = ['Restangular', 'CONF', 'InvoiceUpload', 'Invoice', 'InvoiceStatus', 'InvoiceEvent'];

    /**
     * Accès à l'API concernant les factures
     */

    /* @ngInject */
    function KissInvoiceDA(Restangular, CONF, InvoiceUpload, Invoice, InvoiceStatus, InvoiceEvent) {
        var baseUrl = CONF.apiBaseUrl + '/v1/invoices';
        var baseUrlPreInvoice = CONF.apiBaseUrl + '/v1/preinvoices';

        var exports = {
            searchInvoices: searchInvoices,
            searchPreInvoices: searchPreInvoices,
            getDocumentJson: getDocumentJson,
            getDocumentEvents: getDocumentEvents,
        };

        return exports;

        ////////////////
        /**
         * Recherche des factures sur la docrepo.
         */
        function searchInvoices(searchFilter) {
            return Restangular.one(baseUrl)
                .all('bo-search')
                .post(searchFilter)
                .then(function (invoices) {
                    return {
                        totalElements: invoices.totalElements,
                        invoices: _.map(invoices.content, function (invoice) {
                            return new Invoice(invoice);
                        }),
                    };
                });
        }

        function searchPreInvoices(searchFilter) {
            return Restangular.one(baseUrlPreInvoice)
                .all('search')
                .post(searchFilter)
                .then(function (pageInvoiceUploads) {
                    return {
                        totalItems: pageInvoiceUploads.totalElements,
                        invoices: _.map(pageInvoiceUploads.content, function (iup) {
                            return new InvoiceUpload(iup);
                        }),
                    };
                });
        }

        /**
         * Fournit le Json complet d'un document.
         * @param guid Guid docrepo du document
         */
        function getDocumentJson(guid) {
            return Restangular.one(baseUrl, guid)
                .all('json')
                .customGET()
                .then(function (response) {
                    return JSON.parse(response);
                });
        }

        /**
         * Récupération des événements d'une facture.
         * @param guid Guid du document docrepo
         */
        function getDocumentEvents(guid) {
            return Restangular.one(baseUrl, guid)
                .oneUrl('events')
                .get()
                .then(function (data) {
                    var statusData = {
                        eventList: _.map(data.eventList, function (event) {
                            return new InvoiceEvent(event);
                        }),
                        invoiceNumber: data.invoiceNumber,
                        discussionEvents: _.map(data.discussionEvents, function (event) {
                            return new InvoiceEvent(event);
                        }),
                    };
                    return statusData;
                });
        }
    }
})();
